'use client'
import axios from '@/utils/axiosInterceptor';

const ctrl = {};

ctrl.getAprobaciones = async (cedularuc) => {
    return axios.get('/api/aprobacionPlanos/aprobaciones',{
        params: {
            cedularuc
        }
    })
}

ctrl.getCertificado = async (cedularuc, tramite, tipo) => {
    return axios.get('/api/aprobacionPlanos/certificado',{
        params: {
            cedularuc,
            tramite,
            tipo
        }
    })
}

export default ctrl;